module.exports = __webpack_public_path__ + "img/feature-item-1.eb7f7d05.svg";